import styled from "styled-components";

export const AccountStyledWrapper = styled.div<{ $isMobile?: boolean }>`
  margin-top: ${({ $isMobile }) => ($isMobile ? "10px" : "40px")};
`;
